// extracted by mini-css-extract-plugin
export default {"baseMoney":"zNMGP","isFat":"Qtolf","customCurrencyIcon":"_4i9bn","skeleton-progress":"_8zvUQ"};